<template>
  <v-layout align-center justify-center class="my-10" mx-0 row wrap>
    <v-flex xs12 sm12 md10>
      <v-expansion-panels mandatory accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h2>
              <strong>Crédito MIPYME</strong>
            </h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-layout align-center justify-center row wrap>
              <v-flex xs12 sm12 md6>
                <v-layout justify-center align-center class="primary_dark">
                  <v-flex xs11 sm10>
                    <h3 class="white--text my-12 text-uppercase">
                      {{ title1 }}
                    </h3>
                    <ul>
                      <li
                        class="white--text my-8 font-weight-bold"
                        v-for="(item, index) in items"
                        :key="index"
                      >
                        {{ item.message }}
                      </li>
                    </ul>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex align-self-start xs12 sm12 md6>
                <v-layout justify-center align-center>
                  <v-flex xs11 sm10>
                    <h3
                      :class="[$vuetify.breakpoint.xl ? 'my-7' : 'my-11']"
                      class="primary_dark--text text-uppercase"
                    >
                      {{ title2 }}
                    </h3>
                    <ul>
                      <li
                        class="primary_dark--text my-8 font-weight-bold"
                        v-for="(item, index) in items2"
                        :key="index"
                      >
                        {{ item.message }}
                      </li>
                    </ul>
                    <div
                      class="justify-start my-4"
                      style="color: #1a5c96;font-size: 0.8rem;"
                    >
                      Todos los contratos de nuestros productos, se encuentran
                      debidamente registrados ante la CONDUSEF, en el RECA y
                      pueden ser consultados en las siguientes páginas
                      oficiales:<br />
                      <a
                        style="color: #1a5c96;font-weight: bold;"
                        href="https://www.gob.mx/condusef/"
                        target="_blank"
                        >https://www.gob.mx/condusef/</a
                      >
                      <br />
                      <a
                        style="color: #1a5c96;font-weight: bold;"
                        href="https://phpapps.condusef.gob.mx/reca/_index.php"
                        target="_blank"
                        >https://phpapps.condusef.gob.mx/reca/_index.php</a
                      >
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-flex>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="dialog"
      persistent
      max-width="700px"
    >
      <v-card>
        <v-card-title class="pb-0">
          <v-container class="pb-0">
            <p class="primary--text">Pre-solicitud de Crédito</p>
          </v-container>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Nombre completo *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Correo electronico *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Direccion del negocio * "></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Colonia *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Cuidad o localidad *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Código postal *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12">
                <v-text-field
                  v-mask="'(###)-###-####'"
                  label="Telefono con lada *"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12">
                <v-autocomplete
                  :items="[
                    'Abarrotes',
                    'Carniceria',
                    'Constructora',
                    'Consultorios médicos',
                    'Dulcerías',
                    'Electronica y Computo',
                    'Farmacias',
                    'Fotografia (estudio)',
                    'Fruterías',
                    'Hoteles y Moteles',
                    'Imprentas y editoriales',
                    'Joyeria y relojeria',
                    'Laboratorios clínicos',
                    'Librerias',
                    'Madererías',
                    'Marisquerías',
                    'Mueblería',
                    'Panaderias',
                    'Purificadora de agua',
                    'Refaccionaria',
                    'Restaurante',
                    'Rosticeria',
                    'Talleres',
                    'Telefonia',
                    'Tortillerias',
                    'Videoclub',
                    'Vinos y licores',
                    'Otro comercio o negocio',
                  ]"
                  label="Giro de su negocio * "
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
          <small>*indica el campo requerido</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary_dark" text @click="dialog = false"
            >Enviar solicitud</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<style scoped></style>
<script>
import { mask } from "vue-the-mask";
export default {
  props: ["image"],
  directives: {
    mask,
  },
  data() {
    return {
      dialog: false,
      title1: "Requisitos para reestructura de crédito MIPYME",
      title2: "Condiciones Crediticias:",
      items: [
        {
          message: "Un aval.",
        },
        {
          message: "Comprobante de domicilio del negocio.",
        },
        {
          message: "Credencial de elector de titular y aval.",
        },
        {
          message: "Recibo de predial del solicitante o del aval.",
        },
        {
          message: "Comprobante de domicilio del titular y el aval.",
        },
        {
          message:
            "Alta de hacienda, declaración de impuestos bimestral, notas o facturas del negocio y permiso del ayuntamiento.",
        },
        {
          message: "2 referencias (Un personal y un comercial).",
        },
      ],
      items2: [
        {
          message: "Pago quincenal.",
        },
        {
          message: "Tasa de interes desde el 43% anual mas IVA",
        },
        {
          message: "Comision por Apertura 3% mas iva",
        },
        {
          message:
            "Plazo: 6, 12 y 18 meses (Antigüedad del negocio a partir de 1 año).",
        },
      ],
    };
  },
};
</script>
